import * as React from 'react';
const defaultValue = {};
/**
 * Context for Icon Overrides. Currently in use within the design-systems team only.
 *
 * Please reach out to #design-systems if you have any questions.
 */
export const IconContext = React.createContext(defaultValue);
